import { createContext, useState } from "react";

export const CustomCollectionContext = createContext();

export const CustomCollectionContextProvider = ({ children }) => {
    const [selectedCustomCollections, setSelectedCustomCollections] = useState([]);

    const contextValue = {
        selectedCustomCollections,
        setSelectedCustomCollections
    };

    return (
        <CustomCollectionContext.Provider value={ contextValue }>
            { children }
        </CustomCollectionContext.Provider>
    );
}
